import { Button } from "@/components/ui/button";
import { Routes } from "@/config/routes";
import { useNavigate } from "react-router";

export const NotFound = () => {
	const navigate = useNavigate();
	const onClickButton = () => {
		navigate(Routes.Dashboard.Home.path);
	};

	return (
		<div>
			<div className="space-y-5">
				<h1 className="text-4xl font-bold tracking-tighter sm:text-5xl transition-transform hover:scale-110">
					404
				</h1>
				<p className="text-gray-500">Looks like you've ventured into the unknown digital realm.</p>

				<Button onClick={onClickButton}>Return to app</Button>
			</div>
		</div>
	);
};
